import styled from '@emotion/styled';

import { BREAKPOINTS } from '@/styles/themes/default';
import { IThemeProps } from '@/styles/themes/types';

export const TechologyPartners = styled.section<IThemeProps>`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 24px 16px;

  a {
    grid-column-start: span 2;

    &:last-of-type {
      grid-column: 2 / 4;
    }
  }

  @media (min-width: ${BREAKPOINTS.Tablet.min}px) {
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 32px 44px;

    a {
      grid-column-start: span 1;

      &:last-of-type {
        grid-column: 2 / 3;
      }
    }
  }

  @media (min-width: ${BREAKPOINTS.Desktop.min}px) {
    grid-gap: 40px 64px;
    justify-content: center;
  }
`;
